<template>
  <div class="scrollList">
    <span class="arrowLeft" v-if="!arrivedState.left">
      <slot name="arrowLeft" />
    </span>

    <div class="content" ref="el">
      <slot />
    </div>

    <span class="arrowRight" v-if="!arrivedState.right">
      <slot name="arrowRight" />
    </span>
  </div>
</template>

<script setup lang="ts">
  import { useScroll } from '@vueuse/core'

  const scrollContentRef = useTemplateRef<HTMLElement>('el')
  const { arrivedState } = useScroll(scrollContentRef)
</script>

<style lang="scss" scoped>
.scrollList{
  @apply relative;
  
  .content{
    @apply flex overflow-x-auto overflow-y-hidden snap-mandatory snap-x;
  }
  
  >.arrowLeft,
  >.arrowRight{
    position: absolute;
    top: 0;
    height: 100%;
  }
  
  .arrowLeft{
    left: 0;
  }
  
  .arrowRight{
    right: 0;
  }
}
</style>
